import React from "react";
import { Link, Redirect } from "react-router-dom";
import { ApplicationContext } from "ApplicationContext"
import usesFeatures from 'usesFeatures'
import requests from "request";
import User from "User";
import Icon from "Icon"
import VenueSelector from "VenueSelector";
import LanguageSelector from "LanguageSelector"

class MobileNav extends React.Component {
  static contextType = ApplicationContext

  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  handleLogout = () => {
    let req = requests.delete("logout")
    req.then(({data}) => {
      if (data.success) {
        User.clearAuthToken()
        this.setState({logOut: true})
      }
    })
  }

  toggleMenu = () => {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  closeMenu = () => {
    this.setState({menuOpen: false})
  }

  crossLogLink = () => {
    let host = window.location.host.replace("app.", "internal.")
    let token = User.getAuthToken()
    return [`${window.location.protocol}/`, host, `cross-login?token=${token}`].join("/")
  }

  renderNavItem = (text, link, icon) => {
    const path = window.location.pathname
    const isActive = path == link || (link != "/" && path.includes(link))
    return(
      <li className={`mobile-nav-item ${isActive ? "is-active" : ""}`}>
        <Link to={link} className={`${isActive ? "is-active" : ""}`} onClick={this.closeMenu}>
          <Icon icon={icon} className="nav-icon" />
          <span>{text}</span>
        </Link>
      </li>
    )
  }

  render() {
    if (this.state.logOut) return <Redirect to="/login" />
    const { user, venue, t } = this.props
    const { canUse } = this.context.CurrentUserContext
    const isStoreLimited = user?.storeLimited

    return(
      <>
        <div className="mobile-navbar">
          <div className="mobile-navbar-inner">
            <button
              className={`navbar-burger ${this.state.menuOpen ? 'is-active' : ''}`}
              onClick={this.toggleMenu}
              aria-label="menu"
              aria-expanded={this.state.menuOpen}
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </button>

            <div className="mobile-navbar-brand">
              <a href="/" className="brand">
                <img src="/images/stupid-logo.svg" alt="Logo" />
              </a>
            </div>

            <div className="mobile-navbar-end">
              {venue && (
                <span className="">{venue.name}</span>
              )}
            </div>
          </div>
        </div>

        <div className={`mobile-sidebar-overlay ${this.state.menuOpen ? 'is-active' : ''}`} onClick={this.closeMenu}></div>

        <div className={`mobile-sidebar ${this.state.menuOpen ? 'is-active' : ''}`}>
          <div className="mobile-sidebar-header">
            <div className="mobile-sidebar-brand">
              <img src="/images/stupid-logo.svg" alt="Logo" />
              <h3>Venue Admin</h3>
            </div>
            <button className="mobile-sidebar-close" onClick={this.closeMenu} aria-label="Close menu">
              <Icon icon="times" />
            </button>
          </div>

          {user && (
            <div className="mobile-user-info">
              <div className="user-greeting">
                {t("greeting")} <Link to="/profile" onClick={this.closeMenu}>{user.name}</Link>
              </div>
              {venue && (
                <div className="user-venue">
                  <Link to={`/venue/current`} onClick={this.closeMenu}>{venue.name}</Link>
                </div>
              )}
            </div>
          )}

          <nav className="mobile-nav-menu">
            <ul>
              {!isStoreLimited && this.renderNavItem(t("simple.stores"), "/stores", "store")}
              {!isStoreLimited && this.renderNavItem(t("simple.categories"), "/categories", "tags")}
              {!isStoreLimited && this.renderNavItem(t("simple.products"), "/products", "box-open")}
              {!isStoreLimited && this.renderNavItem(t("simple.discounts"), "/discounts", "percent")}
              {!isStoreLimited && this.renderNavItem(t("simple.orders"), "/orders", "shopping-cart")}
              {this.renderNavItem(t("simple.reports"), "/reports", "chart-line")}
              {!isStoreLimited && this.renderNavItem(t("simple.terminals"), "/terminals", "cash-register")}
              {!isStoreLimited && this.renderNavItem("API Keys", "/api-keys", "key")}
              {!isStoreLimited && this.renderNavItem("Webhooks", "/webhooks", "paper-plane")}
              {!isStoreLimited && initialState.account?.isCustomerDataEnabled &&
                this.renderNavItem(t("simple.customerData"), "/customers", "users")
              }
              {this.renderNavItem("Prepaid Credits", "/prepaid_credits", "credit-card")}
            </ul>
          </nav>

          <div className="mobile-sidebar-footer">
            <div className="mobile-footer-actions">
              <LanguageSelector />
              {user && canUse("change_venue") && (
                <VenueSelector user={user} />
              )}
            </div>

            <div className="mobile-footer-buttons">
              <button className="button is-outlined is-danger is-fullwidth" onClick={this.handleLogout}>
                <Icon icon="sign-out-alt" />
                <span>Logout</span>
              </button>
              {user && canUse("internal") && (
                <a href={this.crossLogLink()} className="button is-link is-fullwidth mt-2">
                  <Icon icon="user-shield" />
                  <span>Internal Login</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default usesFeatures(["translation"], MobileNav)
